/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingbacktoplaces3Inputs */

const en_crosspostingbacktoplaces3 = /** @type {(inputs: Crosspostingbacktoplaces3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to places`)
};

const de_crosspostingbacktoplaces3 = /** @type {(inputs: Crosspostingbacktoplaces3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zu den Orten`)
};

/**
* | output |
* | --- |
* | "Back to places" |
*
* @param {Crosspostingbacktoplaces3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingbacktoplaces3 = /** @type {((inputs?: Crosspostingbacktoplaces3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingbacktoplaces3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingbacktoplaces3(inputs)
	return de_crosspostingbacktoplaces3(inputs)
});
export { crosspostingbacktoplaces3 as "crosspostingBackToPlaces" }